import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import _ from 'underscore';
import 'utils/selectize';

function getSelectize(inputId) {
  return $(`#${inputId}`)[0].selectize;
}

class TagEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = { tags: this.props.tags || [] };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const tags = nextProps.tags || [];
    this.setState({ tags });
  }

  componentDidMount() {
    this.setState({ tags: this.props.tags });
    this.buildSelectize();
    getSelectize(this.getInputId()).on(
      'item_add',
      this.handleItemAdd.bind(this),
    );
    getSelectize(this.getInputId()).on(
      'item_remove',
      this.handleItemRemove.bind(this),
    );
    this.updateTags();
  }

  componentDidUpdate() {
    this.updateTags();
  }

  buildSelectize() {
    const input = $(`#${this.getInputId()}`);

    input.selectize({
      persist: false,
      create: true,
      createOnBlur: true,
      labelField: 'label',
      valueField: 'label',
    });
  }

  handleItemAdd(newTag) {
    if (newTag === '') {
      return;
    }

    if (!_(this.state.tags).find((tag) => tag === newTag)) {
      this.setState(
        (prevState) => {
          const tags = [...prevState.tags, newTag];
          return { tags };
        },
        () => {
          if (
            this.state.tags.length !== this.props.tags.length ||
            !_.isEqual(this.state.tags, this.props.tags)
          ) {
            this.props.handleChange(this.props.object, this.state.tags);
          }
        },
      );
    }
  }

  handleItemRemove(tag) {
    this.setState((prevState) => {
      const tags = _(prevState.tags).without(tag);
      return { tags };
    });
    this.props.handleChange(this.props.object, this.state.tags);
  }

  updateTags() {
    const selectize = getSelectize(this.getInputId());

    selectize.clear();
    selectize.clearOptions();

    _(this.state.tags).each((tag) => {
      selectize.addOption({ label: tag });
      selectize.addItem(tag);
    });

    _(this.props.suggestions).each((suggestion) => {
      selectize.addOption(suggestion);
    });
  }

  getInputId() {
    const { object } = this.props;
    return object?._id ? `input-${object._id}` : 'input';
  }

  render() {
    const { t, dataTestId } = this.props;
    const styles = {
      width: this.props.width ? this.props.width : null,
      float: this.props.pullRight ? 'right' : 'none',
    };
    return (
      (<div
        data-testid={dataTestId}
        className={`form-group ${this.props.wrapperClasses}`}
        style={styles}>
        <div data-testid="div-b6a936e8">
          <input
            className={'tag-editor'}
            data-testid="input-4d18293e"
            id={this.getInputId()}
            type="text"
            ref="tags"
            placeholder={t('TAGS_PLACEHOLDER')} />
        </div>
      </div>)
    );
  }
}

TagEditor.propTypes = {
  tags: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  object: PropTypes.object.isRequired,
  suggestions: PropTypes.array.isRequired,
  width: PropTypes.string,
  pullRight: PropTypes.string,
  wrapperClasses: PropTypes.string,
};

TagEditor.defaultProps = {
  width: null,
  pullRight: null,
  wrapperClasses: '',
};

export default withTranslation()(TagEditor);
